export type UpdateProjectSinglePropertyFormFields = {
  id?: string | number;
  projectId: string | number;
  property: string;
  stringValue?: string;
  integerValue?: number;
};

const _new = ({
  id,
  projectId,
  property,
  stringValue,
  integerValue,
}: {
  id?: string | number;
  projectId: string | number;
  property: string;
  stringValue?: string;
  integerValue?: number;
}): UpdateProjectSinglePropertyFormFields => ({
  id,
  projectId,
  property,
  stringValue,
  integerValue,
});

const edit = ({
  id,
  projectId,
  property,
  stringValue,
  integerValue,
}: {
  id?: string | number;
  projectId: string | number;
  property: string;
  stringValue?: string;
  integerValue?: number;
}): UpdateProjectSinglePropertyFormFields => ({
  id,
  projectId,
  property,
  stringValue,
  integerValue,
});

const toMutation = ({
  id,
  projectId,
  property,
  stringValue,
  integerValue,
}: UpdateProjectSinglePropertyFormFields) => ({
  id,
  projectId,
  property,
  stringValue,
  integerValue,
});

const UpdateSinglePropertyForm = {
  new: _new,
  edit,
  toMutation,
};

export default UpdateSinglePropertyForm;
